<template>
  <article
    :class="`CarouselProductsProduct_index_${index % 3}`"
    class="CarouselProductsProduct"
  >
    <div class="CarouselProductsProduct__image-wrapper">
      <div class="CarouselProductsProduct__image-ratio">
        <BaseImage
          v-if="image"
          :id="image"
          class="CarouselProductsProduct__image"
        />
      </div>
    </div>
    <div class="CarouselProductsProduct__index-container">
      <TextEpsilon
        tag="div"
        class="CarouselProductsProduct__index-text"
        v-text="(index + 1).toString().padStart(2, '0')"
      />
    </div>
    <div class="CarouselProductsProduct__content">
      <h2
        is="TextBeta"
        class="CarouselProductsProduct__heading"
        v-text="heading"
      />
      <p
        class="CarouselProductsProduct__description"
        v-text="description"
      />
      <LinkButton
        v-if="slug && category"
        :to="{ name: 'program', params: { category: category.slug, program: slug } }"
        class="CarouselProductsProduct__link"
      >{{ category.name }} Info</LinkButton>
    </div>
  </article>
</template>

<script>
  import Program from '@/api/programs';
  import Category from '@/api/categories';

  import TextBeta from './TextBeta';
  import LinkButton from './LinkButton';
  import TextEpsilon from './TextEpsilon';

  export default {
    components: {
      TextBeta,
      LinkButton,
      TextEpsilon,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        slug: undefined,
        image: undefined,
        heading: undefined,
        category: undefined,
        description: undefined,
      };
    },
    async created() {
      const {
        slug: productSlug,
        acf: {
          feature: { image, heading, description },
        },
        'product-categories': [categoryId],
      } = await Program.find(this.id);

      this.slug = productSlug;
      this.image = image;
      this.heading = heading;
      this.description = description;

      if (!categoryId) {
        return;
      }

      const {
        slug: categorySlug,
        acf: { singular_name: name },
      } = await Category.find(categoryId);

      this.category = { slug: categorySlug, name };
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .CarouselProductsProduct {
    border-top: border(bronze);
    height: 100%;

    @include breakpoint(phablet) {
      display: flex;
      align-items: center;
      border-top-style: none;
    }
  }

  .CarouselProductsProduct_index_0 {
    background-color: color(blue);
  }

  .CarouselProductsProduct_index_1 {
    background-color: color(red);
  }

  .CarouselProductsProduct_index_2 {
    background-color: color(gold);
  }

  .CarouselProductsProduct__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: spacing(base-epsilon) spacing(base-delta);
    color: color(white);
    text-align: center;

    @include breakpoint(phablet) {
      padding: spacing(base-epsilon) spacing(base-zeta);
      width: 50%;
      align-items: flex-start;
      text-align: left;
    }
  }

  .CarouselProductsProduct__description {
    line-height: line-height(copy);

    .CarouselProductsProduct__heading + & {
      margin-top: spacing(base-gamma);
    }
  }

  .CarouselProductsProduct__image {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .CarouselProductsProduct__image-ratio {
    position: relative;
    padding-top: percentage(9 / 16);

    @include breakpoint(phablet) {
      padding-top: 0;
      height: 100%;
    }
  }

  .CarouselProductsProduct__image-wrapper {
    @include breakpoint(phablet) {
      width: 50%;
      height: 100%;
    }
  }

  .CarouselProductsProduct__index-container {
    $size: 36px;

    display: flex;
    margin: $size / -2 auto;
    width: $size;
    height: $size;
    background-color: color(bronze);
    transform: rotate(45deg);
    justify-content: center;
    align-items: center;
    content: '';

    @include breakpoint(phablet) {
      $size: 48px;

      margin: 0 $size / -2;
      width: $size;
      height: $size;
    }
  }

  .CarouselProductsProduct__index-text {
    transform: rotate(-45deg);
    color: color(white);
  }

  .CarouselProductsProduct__link {
    margin-top: spacing(base-gamma);
  }
</style>
